import { render, staticRenderFns } from "./product-center.vue?vue&type=template&id=7167a8ea&scoped=true"
import script from "./product-center.vue?vue&type=script&lang=js"
export * from "./product-center.vue?vue&type=script&lang=js"
import style0 from "./product-center.vue?vue&type=style&index=0&id=7167a8ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_j7fuxwmg3pjjrof4ryv5g7uhre/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7167a8ea",
  null
  
)

export default component.exports